'use strict';

var SchemeTools = {
    Modes: {
        ADD: 'add',
        EDIT: 'edit',
        DELETE: 'delete',
    },
    ElementTypes: {
        VALUE: 'value',
        TEXT: 'text',
    },
};

module.exports = SchemeTools;
